// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2999":"515f0737","3145":"515f0737","4226":"515f0737","4686":"515f0737","7030":"515f0737"}[chunkId] + ".chunk.css";
};